var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',{attrs:{"funcionalidade":"livro-psicotropico"},on:{"update":function($event){return _vm.$emit('update')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }